
import { FormState__setValidationResponse_5219762A, FormState__startLoading, InventoryConfiguration as InventoryConfiguration_7, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { updateInventoryConfiguration, getCustomerConfiguration } from "../../../Requests/Configuration.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";

export const initialState = new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, Cmd_batch(singleton(getCustomerConfiguration((Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(10, [Item_1])))))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = state.InventoryConfiguration;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const inventoryConfiguration_1 = matchValue_1.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new InventoryConfiguration_7(inventoryConfiguration_1.InventoryNumberUnique, msg.fields[0], inventoryConfiguration_1.AllowQRCodeAssignmentMultipleTimes, inventoryConfiguration_1.BookingHistoryRetentionYears, inventoryConfiguration_1.PlannedReturnDateMandatory, inventoryConfiguration_1.CompletenessCheckOnSetReturnRequired, inventoryConfiguration_1.CompletenessCheckOnSetReturnScanOnly)]), state.FormState), Cmd_none()];
            }
        }
        case 2: {
            const matchValue_2 = state.InventoryConfiguration;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const inventoryConfiguration_2 = matchValue_2.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new InventoryConfiguration_7(inventoryConfiguration_2.InventoryNumberUnique, inventoryConfiguration_2.InventoryNumberAutomaticIncrease, msg.fields[0], inventoryConfiguration_2.BookingHistoryRetentionYears, inventoryConfiguration_2.PlannedReturnDateMandatory, inventoryConfiguration_2.CompletenessCheckOnSetReturnRequired, inventoryConfiguration_2.CompletenessCheckOnSetReturnScanOnly)]), state.FormState), Cmd_none()];
            }
        }
        case 3: {
            const matchValue_3 = state.InventoryConfiguration;
            if (matchValue_3.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const inventoryConfiguration_3 = matchValue_3.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new InventoryConfiguration_7(inventoryConfiguration_3.InventoryNumberUnique, inventoryConfiguration_3.InventoryNumberAutomaticIncrease, inventoryConfiguration_3.AllowQRCodeAssignmentMultipleTimes, msg.fields[0], inventoryConfiguration_3.PlannedReturnDateMandatory, inventoryConfiguration_3.CompletenessCheckOnSetReturnRequired, inventoryConfiguration_3.CompletenessCheckOnSetReturnScanOnly)]), state.FormState), Cmd_none()];
            }
        }
        case 4: {
            const matchValue_4 = state.InventoryConfiguration;
            if (matchValue_4.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const inventoryConfiguration_4 = matchValue_4.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new InventoryConfiguration_7(inventoryConfiguration_4.InventoryNumberUnique, inventoryConfiguration_4.InventoryNumberAutomaticIncrease, inventoryConfiguration_4.AllowQRCodeAssignmentMultipleTimes, inventoryConfiguration_4.BookingHistoryRetentionYears, msg.fields[0], inventoryConfiguration_4.CompletenessCheckOnSetReturnRequired, inventoryConfiguration_4.CompletenessCheckOnSetReturnScanOnly)]), state.FormState), Cmd_none()];
            }
        }
        case 5: {
            const matchValue_5 = state.InventoryConfiguration;
            if (matchValue_5.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const inventoryConfiguration_5 = matchValue_5.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new InventoryConfiguration_7(inventoryConfiguration_5.InventoryNumberUnique, inventoryConfiguration_5.InventoryNumberAutomaticIncrease, inventoryConfiguration_5.AllowQRCodeAssignmentMultipleTimes, inventoryConfiguration_5.BookingHistoryRetentionYears, inventoryConfiguration_5.PlannedReturnDateMandatory, msg.fields[0], inventoryConfiguration_5.CompletenessCheckOnSetReturnScanOnly)]), state.FormState), Cmd_none()];
            }
        }
        case 6: {
            const matchValue_6 = state.InventoryConfiguration;
            if (matchValue_6.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const inventoryConfiguration_6 = matchValue_6.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new InventoryConfiguration_7(inventoryConfiguration_6.InventoryNumberUnique, inventoryConfiguration_6.InventoryNumberAutomaticIncrease, inventoryConfiguration_6.AllowQRCodeAssignmentMultipleTimes, inventoryConfiguration_6.BookingHistoryRetentionYears, inventoryConfiguration_6.PlannedReturnDateMandatory, inventoryConfiguration_6.CompletenessCheckOnSetReturnRequired, msg.fields[0])]), state.FormState), Cmd_none()];
            }
        }
        case 8: {
            const matchValue_7 = state.InventoryConfiguration;
            if (matchValue_7.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.CustomerConfiguration, state.InventoryConfiguration, FormState__startLoading(state.FormState)), updateInventoryConfiguration(matchValue_7.fields[0], (Item_7) => (new Msg(9, [Item_7])), (Item_8) => (new Msg(10, [Item_8])))];
            }
        }
        case 7: {
            const response = msg.fields[0];
            return [new State(new RequestedValue$1(1, [response]), new RequestedValue$1(1, [response.InventoryConfiguration]), state.FormState), Cmd_none()];
        }
        case 9: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.CustomerConfiguration, state.InventoryConfiguration, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CustomerConfiguration, state.InventoryConfiguration, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("settings.permissions_changed_successful"), getCustomerConfiguration((Item_9) => (new Msg(7, [Item_9])), (Item_10) => (new Msg(10, [Item_10])))]))];
            }
        }
        case 10:
            return [new State(state.CustomerConfiguration, state.InventoryConfiguration, FormState_get_empty()), Cmd_none()];
        default: {
            const matchValue = state.InventoryConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const inventoryConfiguration = matchValue.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new InventoryConfiguration_7(msg.fields[0], inventoryConfiguration.InventoryNumberAutomaticIncrease, inventoryConfiguration.AllowQRCodeAssignmentMultipleTimes, inventoryConfiguration.BookingHistoryRetentionYears, inventoryConfiguration.PlannedReturnDateMandatory, inventoryConfiguration.CompletenessCheckOnSetReturnRequired, inventoryConfiguration.CompletenessCheckOnSetReturnScanOnly)]), state.FormState), Cmd_none()];
            }
        }
    }
}

